import { ReduxStore, PaxMQState, MQContent, MQCategory } from '@trip-ux/redux-store';
import { find, get, toLower, set, merge } from 'lodash';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

export const labelsSelector = (store: ReduxStore, translationField = 'translation'): any => {
  //NOSONAR
  const translationDocument = get(store, `config.options.${translationField}`);
  const translationSpace = get(store, 'config.options.translationSpace');
  const found = find(
    store.tms.labels,
    label => label.translation === translationDocument && label.translationSpace === translationSpace
  );
  const raw = get(found, 'data', {});

  // Normalize flat dot-key maps into nested objects.
  // e.g. { 'user_listing.heading': 'Title' } -> { user_listing: { heading: 'Title' } }
  const flatToNested = (input: any) => {
    if (!input || typeof input !== 'object') return {};
    const result: any = {};
    Object.entries(input).forEach(([k, v]) => {
      // lodash `set` will interpret dotted keys and create nested structures
      set(result, k, v);
    });
    // merge original nested structures on top so explicit nested entries win over flat ones
    return merge({}, result, input);
  };

  return flatToNested(raw);
};

export const isLabelFetched = (store: ReduxStore, translationField = 'translation'): boolean => {
  const translationDocument = get(store, `config.options.${translationField}`);
  const translationSpace = get(store, 'config.options.translationSpace');
  return get(
    find(
      store.tms.labels,
      label => label.translation === translationDocument && label.translationSpace === translationSpace
    ),
    'fetched',
    false
  );
};

export const medAnswerSelector = (store: ReduxStore, paxId: number): PaxMQState[] => get(store.medQuestionnaire, paxId);

export const medDecSelector = (store: ReduxStore, planClass: string): MQContent =>
  find(get(store.contentFragment, 'medicalQuestionnaire'), medDec => toLower(medDec.planClass) === toLower(planClass));

export const naSelector = (store: ReduxStore): MQContent => {
  return get(store.contentFragment, 'needAnalysisQuestionnaire.0');
};

export const medCategorySelector = (store: ReduxStore, paxId: number): MQCategory =>
  // @ts-ignore
  get(store.medQuestionnaire, `rateCategory[${paxId}]`, {});
